import {useMemo} from 'react';

import {AppCategory} from '@web-catalog/types';

import {BreadcrumbsBackstackItem} from '@web-catalog/ui-kit/Breadcrumbs';

import {getBreadcrumbsBackstackForCategory} from '@web-catalog/utils/breadcrumbs';

export const useBreadcrumbsBackstackForCategory = ({
  category,
  isGamesPage = false,
}: {
  category: AppCategory | null | undefined;
  isGamesPage?: boolean;
}) => {
  return useMemo<Array<BreadcrumbsBackstackItem>>(() => {
    return getBreadcrumbsBackstackForCategory({category, isGamesPage});
  }, [category, isGamesPage]);
};
